import helpers from '../common/helpers';

let numeral = require('numeral');
numeral.register('locale', 'pt-BR', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'mil',
    million: 'mi',
    billion: 'bi',
    trillion: 'tri'
  },
  currency: {
    symbol: 'R$'
  }
});

numeral.locale('pt-BR');

(function ($) {
  "use strict";

  const cntsSimulator = {
    init: function () {
      this.setup();
      this.start();
      this.bind();
    },
    setup() {
      this.options = {
        baseRentabilidade: $('input[name="baseRentabilidade"]').val() || 6.18,
        baseSelic: $('input[name="baseSelic"]').val() || 3.75,
        basePoupanca: $('input[name="baseSelic"]').val() * 0.7,
        baseCDI: $('input[name="baseCDI"]').val() || 0.33,
        baseIPCA: $('input[name="baseIPCA"]').val() || 3.50,

        $inputInvestimentoMensal: $('input[name="inputInvestimentoMensal"]'),
        $inputTempoInvestimento: $('input[name="inputTempoInvestimento"]'),
        $inputRendaMensalAposentadoria: $('input[name="inputRendaMensalAposentadoria"]'),
        $inputQuantoTempoReceber: $('input[name="inputQuantoTempoReceber"]'),

        $labelInvestimentoMensal: $('label[for="inputInvestimentoMensal"]'),
        $labelTempoInvestimento: $('label[for="inputTempoInvestimento"]'),
        $labelRendaMensalAposentadoria: $('label[for="inputRendaMensalAposentadoria"]'),
        $labelQuantoTempoReceber: $('label[for="inputQuantoTempoReceber"]'),

        inputInvestimentoMensal: $('input[name="inputInvestimentoMensal"]').val(),
        inputTempoInvestimento: $('input[name="inputTempoInvestimento"]').val(),
        inputRendaMensalAposentadoria: $('input[name="inputRendaMensalAposentadoria"]').val(),
        inputQuantoTempoReceber: $('input[name="inputQuantoTempoReceber"]').val()
      };
    },
    bind() {
      this.bindChangeInput();
      // this.bindShowLabels();
    },
    start() {
      const {
        $inputTempoInvestimento,
        $inputRendaMensalAposentadoria,
        $inputQuantoTempoReceber,
        $labelTempoInvestimento,
        $labelRendaMensalAposentadoria,
        $labelQuantoTempoReceber
      } = this.options;

      console.log('init >>>>',$inputTempoInvestimento.val(), $inputRendaMensalAposentadoria.val(), $inputQuantoTempoReceber.val())

      if ($inputTempoInvestimento.val() > 0 && $inputRendaMensalAposentadoria.val() > 0 && $inputQuantoTempoReceber.val() > 0) {
        this.insertValueLabel($labelTempoInvestimento, $inputTempoInvestimento.val());
        this.insertValueLabel($labelRendaMensalAposentadoria, $inputRendaMensalAposentadoria.val(), parseInt($inputRendaMensalAposentadoria.val()).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
        this.insertValueLabel($labelQuantoTempoReceber, $inputQuantoTempoReceber.val());
        this.calculatedInit();
      }
    },

    bindChangeInput() {
      const {
        $inputTempoInvestimento,
        $inputRendaMensalAposentadoria,
        $inputQuantoTempoReceber,
        $labelTempoInvestimento,
        $labelRendaMensalAposentadoria,
        $labelQuantoTempoReceber
      } = this.options;

      const _this = this;

      $inputTempoInvestimento.change(function () {
        let val = $(this).val();
        _this.options.inputTempoInvestimento = val;

        _this.insertValueLabel($labelTempoInvestimento, val);

        if ($(this).val() > 0 && $inputRendaMensalAposentadoria.val() > 0 && $inputQuantoTempoReceber.val() > 0) {
          _this.calculatedInit();
        }
      });

      $inputRendaMensalAposentadoria.change(function () {
        _this.options.inputRendaMensalAposentadoria = $(this).val();
        let val = parseInt($(this).val())
        let valFormat = val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

        _this.insertValueLabel($labelRendaMensalAposentadoria, val, valFormat);

        if ($inputTempoInvestimento.val() > 0 && $(this).val() > 0 && $inputQuantoTempoReceber.val() > 0) {
          _this.calculatedInit();
        }
      });

      $inputQuantoTempoReceber.change(function () {
        let val = $(this).val();

        _this.options.inputQuantoTempoReceber = val;
        _this.insertValueLabel($labelQuantoTempoReceber, val);

        if ($inputTempoInvestimento.val() > 0 && $inputRendaMensalAposentadoria.val() > 0 && $(this).val() > 0) {
          _this.calculatedInit();
        }
      });
    },

    calculatedInit() {
      const { baseRentabilidade, baseSelic, basePoupanca, baseCDI, baseIPCA, inputTempoInvestimento, inputRendaMensalAposentadoria, inputQuantoTempoReceber, $labelInvestimentoMensal } = this.options

      let x1TempoPoupar = inputTempoInvestimento,
        x2ValorAReceber = inputRendaMensalAposentadoria,
        x3TempoParaReceber = inputQuantoTempoReceber;

      let tempoPoupanca = x1TempoPoupar * 12,
        //rendaAposentar = x2ValorAReceber,
        tempoRecebimentoRenda = x3TempoParaReceber * 12;

      let rentabilidade = (this.calculatePower(baseRentabilidade, 1 / 12) * 100);

      let rangeList = this.createRange(tempoRecebimentoRenda, x2ValorAReceber);
      let vpl = this.calculateNPV(rentabilidade, 0, rangeList);

      let somaPG = vpl;
      let somaPGFormat = somaPG.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

      let multiplicador = (this.calculatePower(baseRentabilidade, 1 / 12) * 100);
      multiplicador = this.calculatePower(multiplicador, tempoPoupanca) / (1 + (multiplicador / 100) - 1);

      let contribuicao = somaPG / multiplicador;
      let selic = (this.calculatePower((baseSelic), 1 / 12) * 100);
      let poupanca = (this.calculatePower((basePoupanca), 1 / 12) * 100);
      let cdi = baseCDI;
      let ipca = (this.calculatePower(baseIPCA, 1 / 12) * 100).toFixed(2);


      let saldoSelic = (this.calculateFV(selic / 100, tempoPoupanca, contribuicao) * -1);
      let saldoPoupanca = (this.calculateFV(poupanca / 100, tempoPoupanca, contribuicao) * -1);
      let saldoCDI = (this.calculateFV(cdi / 100, tempoPoupanca, contribuicao) * -1);
      let centrusPrev = somaPG;

     /*  console.log('saldoSelic:', saldoSelic)
      console.log('saldoPoupanca:', saldoPoupanca)
      console.log('saldoCDI:', saldoCDI)
      console.log('centrusPrev:', centrusPrev) */


      let saldoPoupancaFormat = saldoPoupanca.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      let saldoCDIFormat = saldoCDI.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      let saldoSelicFormat = saldoSelic.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      let centrusPrevFormat = somaPGFormat;

      let saldoInvestimento = contribuicao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      this.options.inputInvestimentoMensal = contribuicao;
      $labelInvestimentoMensal.find('span').html(saldoInvestimento);


      let maxValue = this.getMaxValue([centrusPrev, saldoSelic, saldoPoupanca, saldoCDI]);
      // let pctCentrus = (centrusPrev * 96) / maxValue;
      // let pctTesouro = (saldoSelic * 96) / maxValue;
      // let pctPoupanca = (saldoPoupanca * 96) / maxValue;
      // let pctCDI = (saldoCDI * 96) / maxValue;

      this.setPercentageBar($('#result-centrusprev'), centrusPrev, centrusPrevFormat, maxValue);
      this.setPercentageBar($('#result-tesouro'), saldoSelic, saldoSelicFormat, maxValue);
      this.setPercentageBar($('#result-poupanca'), saldoPoupanca, saldoPoupancaFormat, maxValue);
      this.setPercentageBar($('#result-cdi'), saldoCDI, saldoCDIFormat, maxValue);
    },

    insertValueLabel($label, value, valueFormat) {
      const {
        $labelInvestimentoMensal,
        inputInvestimentoMensal
      } = this.options;

      if(valueFormat == "" || valueFormat == undefined){
        valueFormat = value
      }

      $label.find('span').html(valueFormat);

      if (value > 0) {
        $label.slideDown()
      } else {
        $label.slideUp()
      }

      if(inputInvestimentoMensal > 0) {
        $labelInvestimentoMensal.slideDown()
      } else {
        $labelInvestimentoMensal.slideUp()
      }
    },

    getMaxValue(array) {
      return array.reduce(
        (a, b) =>
          Math.max(a, b)
      );
    },

    setPercentageBar($el, value, valueFormat, maxValue) {
      let pct, left;

      let formatNumber = numeral(value).format('($ 0.00 a)');
      // let formatNumber = numeral(value).format('0 a');
      // console.log('valor >>>>>', formatNumber);

      $el.find('.result-value').html(formatNumber);

      if (!helpers.isMobile() && cnts.windowWidth > '992') {
        pct = (value * 98) / maxValue;
        left = "2%";

      } else {
        pct = (value * 95) / maxValue;
        left = "5%";
      }

      $el.find('.item-bar__number').css("width", pct + '%');
      $el.find('.progress').css({ "width": pct + '%', "left": left });
    },

    createRange(end, value) {
      let rowInit = 1;
      let rowEnd = end || 0;
      let list = Array(rowEnd - rowInit + 1)
        .fill()
        .map(() => value);

      return list;
    },

    calculatePower(base, exponent) {
      return Math.pow(1 + (base / 100), exponent) - 1;
    },

    calculateFV(rate, nper, pmt, pv, type) {
      // console.log('calculateFV', rate, nper, pmt, pv, type);
      let pow = Math.pow(1 + rate, nper),
        fv;
      pv = pv || 0;
      type = type || 0;
      if (rate) {
        fv = (pmt * (1 + rate * type) * (1 - pow)) / rate - pv * pow;
      } else {
        fv = -1 * (pv + pmt * nper);
      }
      return fv;
    },

    calculateNPV(rate, initialCost, cashFlows) {
      return cashFlows.reduce(
        (accumulator, currentValue, index) =>
          accumulator + currentValue / Math.pow(rate / 100 + 1, index + 1),
        initialCost
      );
    }
  };

  $(document).ready(function () {
    if ($("body").hasClass("single-plano")) {
      cntsSimulator.init();
    }
  });

  $(window).resize(function () { });
})(jQuery);
